import { render } from "./PurchaseReceive.vue?vue&type=template&id=25271fa6&scoped=true"
import script from "./PurchaseReceive.vue?vue&type=script&lang=js"
export * from "./PurchaseReceive.vue?vue&type=script&lang=js"

import "./PurchaseReceive.vue?vue&type=style&index=0&id=25271fa6&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25271fa6"]])

export default __exports__